import { Stack, Text } from '@fluentui/react';
import React from 'react';
import { ConditionDataProps } from '../../Conditions';
import { CONDITION_NODE_WIDTH, MAX_CHAR_COUNT } from '../../../constants';

export const Body: React.FC<{ data: ConditionDataProps }> = ({ data }) => {
  const lines = [
    data?._infoLines?.infoLine1,
    data?._infoLines?.infoLine2,
    data?._infoLines?.infoLine3,
  ].filter(Boolean); // remove undefined/null lines

  let totalChars = 0;
  const displayLines: string[] = [];

  for (const line of lines) {
    if (line) {
      if (totalChars + line.length <= MAX_CHAR_COUNT) {
        displayLines.push(line);
        totalChars += line.length;
      } else {
        const remaining = MAX_CHAR_COUNT - totalChars;
        if (remaining > 0) {
          displayLines.push(line.slice(0, remaining) + '...');
        }
        break; // stop after reaching max
      }
    }
  }

  return (
    <Stack tokens={{ childrenGap: 5, padding: '5px 10px' }}>
      <Stack style={{ width: CONDITION_NODE_WIDTH - 20 }}>
        {displayLines.map((text, index) => (
          <Text
            key={index}
            variant="small"
            styles={{
              root: {
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              },
            }}
          >
            {text}
          </Text>
        ))}
      </Stack>
    </Stack>
  );
};
